/**
 * Creates an event-handler that calls the provided function only if the enter key is pressed.
 *
 * @param {function} funcOnEnter function to call when enter is pressed
 */
export const callOnEnter = (funcOnEnter) => (e) => {
  if (e.keyCode === 13) funcOnEnter(e);
};

/**
 * Credit: https://gist.github.com/MoOx/12726d85a3343d84ee3c
 */

// Maximum delay between taps to consider it a double-tap
const dblTouchTapMaxDelay = 300;

// Stores the last element to register a tap and the time at which it was received.
let latestTouchTap = {
  time: 0,
  target: null,
};

/**
 * Checks if a current tap event is part of a double tap.
 *
 * It does this by saving the time and target of the initial tap event, and then comparing it
 * checking it against the time and target of the next tap event. If the same target is tapped with
 * a gap that is under a certain threshold it considers that second tap even a double tap.
 * @param event
 * @returns {boolean}
 */
export function isDblTouchTap(event) {
  const touchTap = {
    time: new Date().getTime(),
    target: event.currentTarget,
  };
  const isFastDblTouchTap = (
    touchTap.target === latestTouchTap.target &&
    touchTap.time - latestTouchTap.time < dblTouchTapMaxDelay
  );

  latestTouchTap = touchTap;

  return isFastDblTouchTap;
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils/eventHelpers.js